<template>
  <div
    @focusin="hasFocus = true"
    @focusout="hasFocus = false"
    class="rounded border text-sm overflow-hidden"
    :class="[{ 'bg-cockpit-elevated opacity-60': disabled, 'bg-cockpit-canvas': !disabled }, error ? 'border-cockpit-critical' : hasFocus ? 'border-cockpit-green' : 'border-cockpit-line', size]">
    <slot />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  disabled: Boolean,
  error: Boolean,
  dense: Boolean,
  square: Boolean,
})

const hasFocus = ref(false)

const size = computed(() => {
  if (props.square) return 'size-6'
  if (props.dense) return 'h-[28px]'
  return 'h-[42px]'
})
</script>
